import React, { useEffect, useMemo } from 'react';
import {
    clearEvents,
    getStaticData,
    setEventType,
    setSportRefId,
} from '../../../store/actions/sportEvents';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { generateQuery } from '../../../utils/helpers';
import AllMarkets from '../../AllMarkets/AllMarkets';
import { generateEventFilters } from '../../../constants/event-filters';
import { EVENT_TYPE_ENUM } from '../../../constants/enums';
import { EVENT_TYPES, LANGUAGES } from '../../../constants/defaultValues';
import { setAllMarketsSelectedEvent } from '../../../store/actions/markets';
import { clearOutrights } from '../../../store/actions/outrights';
import classnames from 'classnames';
import SportTitle from '../Events/SportTitle/SportTitle';
import LiveFilters from '../Events/LiveFilters/LiveFilters';
import Title from '../../shared/Title/Title';
import PreMatchFilters from '../Events/PreMatchFilters/PreMatchFilters';
import OutrightEvents from '../Events/OutrightEvents/OutrightEvents';
import RegularEvents from '../Events/RegularEvents/RegularEvents';
import styles from './Container.module.scss';

const Container = ({ showAllMarkets }) => {
    const dispatch = useDispatch();
    const { sportRefId } = useParams();

    const locale = useSelector(state => state.settings.locale);
    const sportsList = useSelector(state => state.sportTypes.sportsList);
    const { isLive, isESports, eventType, isFiltersFetching } = useSelector(
        state => state.sportEvents
    );

    const decodedSportRefId = useMemo(() => decodeURIComponent(sportRefId), [sportRefId]);
    const sportName = useMemo(() => {
        const sport = sportsList.find(sport => sport.referenceId === decodedSportRefId);
        return sport ? sport.names[locale] || sport.names[LANGUAGES.eng] : '';
    }, [sportsList, decodedSportRefId]);
    const isOutrightsSelected = useMemo(
        () => eventType.value === EVENT_TYPE_ENUM.outright,
        [eventType]
    );

    useEffect(() => {
        if (isLive === null) return;

        const filters = generateEventFilters({
            sportRefId: decodedSportRefId,
            isLive,
            isESports,
            isOutrights: isOutrightsSelected,
            eventType: eventType.value,
        });
        const query = generateQuery(filters);

        dispatch(setSportRefId(decodedSportRefId));
        // dispatch(changeEventFilters({ filters, shouldUpdateEvents: false }));
        dispatch(
            getStaticData({
                sportTypeId: decodedSportRefId,
                live: isLive,
                startDate: query.startDate,
                endDate: query.endDate,
                eventType: eventType.value,
                isESports,
            })
        );

        return () => {
            dispatch(clearEvents());
            dispatch(clearOutrights());
        };
    }, [decodedSportRefId, isLive, eventType]);

    useEffect(() => {
        dispatch(setEventType(EVENT_TYPES[0]));
    }, [isLive, isESports]);

    useEffect(() => {
        dispatch(setAllMarketsSelectedEvent({}));
    }, [decodedSportRefId]);

    return (
        <>
            <div
                className={classnames(styles.container, {
                    [styles.live]: isLive,
                })}
            >
                {isLive ? (
                    <>
                        <SportTitle title={sportName} isLive sportId={sportRefId} />
                        {!isFiltersFetching && <LiveFilters />}
                    </>
                ) : (
                    <>
                        <Title title={sportName} />
                        {!isFiltersFetching && <PreMatchFilters />}
                    </>
                )}
                <div
                    className={classnames(styles.content, {
                        [styles.live]: isLive,
                    })}
                >
                    {isOutrightsSelected ? <OutrightEvents /> : <RegularEvents />}
                </div>
            </div>
            {showAllMarkets && <AllMarkets />}
        </>
    );
};

export default Container;
